export const GET_SHARE_WISHLIST = /* GraphQL */ `
    mutation getShareWishList($code: String!) {
        getShareWishList(code: $code) {
            items_count
            name
            sharing_code
            customer_name
            updated_at
            items {
                id
                share_configurable_options {
                    id
                    value_id
                    option_label
                    value_label
                }
                product {
                    __typename
                    id
                    uid
                    name
                    sku
                    ... on ConfigurableProduct {
                        variants {
                            __typename
                            attributes {
                                __typename
                                uid
                                value_index
                            }
                            product {
                                sku
                            }
                        }
                    }
                    url_key
                    small_image {
                        __typename
                        url
                    }
                    price_range {
                        __typename
                        minimum_price {
                            __typename
                            regular_price {
                                __typename
                                value
                                currency
                            }
                            final_price {
                                __typename
                                value
                                currency
                            }
                            discount {
                                __typename
                                amount_off
                            }
                        }
                        maximum_price {
                            __typename
                            final_price {
                                __typename
                                value
                                currency
                            }
                        }
                    }
                }
            }
        }
    }
`
